export const withPreventDefault = (cb: () => void) => (e) => {
  e.preventDefault();
  cb();
};

export const withStopPropagation = (cb: () => void) => (e) => {
  e.stopPropagation();
  cb();
};
